angular.module('SpidApp')

.factory('Cart',
		['Sale', 'Stamp',
function (Sale,   Stamp) {
	var Cart = function () {
		this.objects         = [];
		  
		this.recu            = null;
		this.balance         = 0;
		this.totalPrice      = 0;
		this.totalLocalPrice = 0;
		this.transaction_id  = 0;

		this.validated = false;
	}

	Cart.prototype.setUnvalidated = function () {
		this.validated = false
	}

	Cart.prototype.setValidated = function () {
		if (!this.isValidable()) {
			throw 'Cart::setValidated() - Cart is not in a validable state'
		}
		
		this.validated = true
	}

	Cart.prototype.flush = function () {
		Cart.call(this)
	}

	Cart.prototype.isEmpty = function () {
		return !this.objects || this.objects.length === 0
	}

	Cart.prototype.removeSale = function (index) {
		if (this.isValidated()) {
			throw 'Cart::removeSale() - Cart is already validated'
		}

		if (index === null || index === undefined || index < 0) {
			throw "Cart::removeSale() - Malformed parameters"
		}

		this.objects.splice(index, 1);
		this._updateTotal();
	}

	Cart.prototype._addSale = function (sale) {
		if (this.isValidated()) {
			throw 'Cart::_addSale() - Cart is already validated'
		}
		
		this.objects.push(sale)
	}
	
	Cart.prototype._updateTotal = function () {
		this.totalPrice = _.reduce(this.objects, function (memo, object) {
			return memo + (object.type === Sale.REFUND ? -1 : 1) * object.price * (object.quantity ? object.quantity : 0)
		}, 0)
		
		this.totalLocalPrice = _.reduce(this.objects, function (memo, object) {
			return memo + (object.type === Sale.REFUND ? -1 : 1) * object.localPrice * (object.quantity ? object.quantity : 0)
		}, 0)
		
		this.updateBalance();
	}
	
	Cart.prototype.updateTotal = function () {
		this._updateTotal()
	}

	Cart.prototype.incrementSaleQuantity = function (sale) {
		if (this.isValidated()) {
			throw 'Cart::incrementSaleQuantity() - Cart is already validated'
		}
		
		if (!sale) {
			throw 'Cart::incrementSaleQuantity() - Missing parameters'
		}

		sale.incrementQuantity()
		this._updateTotal()
	}

	Cart.prototype.decrementSaleQuantity = function (sale) {
		if (this.isValidated()) {
			throw 'Cart::decrementSaleQuantity() - Cart is already validated'
		}
		
		if (!sale) {
			throw 'Cart::decrementSaleQuantity() - Missing parameters'
		}

		sale.decrementQuantity()
		this._updateTotal()
	}

	Cart.prototype.addStamp = function (stamp, params) {
		params = params || {}

		if (this.isValidated()) {
			throw 'Cart::addStamp() - Cart is already validated'
		}
		
		var label                 = params.label
		var quantity              = params.quantity
		var price                 = params.price
		var localPrice            = params.localPrice
		var weight                = params.weight
		var code_affranchissement = params.code_affranchissement
		var code_destination      = params.code_destination
		var deno_services         = params.deno_services || ''
		
		if (!label || !quantity || !price) {
			throw 'Cart::addStamp() - Missing parameters (label, quantity, price)'
		}
		
		if (Stamp.types.SIMPLE !== label && (!stamp || !weight)) {
			throw 'Cart::addStamp() - Missing parameters (weight)'
		}

		var sale = new Sale(Sale.STAMP, _.extend(stamp, {
			  label                 : label
			, quantity              : quantity
			, price                 : price
			, localPrice            : localPrice
			, weight                : weight
			, code_affranchissement : code_affranchissement
			, code_destination      : code_destination
			, deno_services         : deno_services
		}))

		this._addSale(sale)
		this._updateTotal()
		
		return sale
	}

	Cart.prototype.addProduct = function (product, quantity) {
		if (this.isValidated()) {
			throw 'Cart::addProduct() - Cart is already validated'
		}
		
		if (!product) {
			throw 'Cart::addProduct() - Missing parameters'
		}

		var previousInstance = _.chain(this.objects).find(function (o) {
			return o.id === product.id
		}).value()
		
		if (!previousInstance) {
			var sale = new Sale(Sale.PRODUCT, _.extend(product, { quantity : quantity }))
			this._addSale(sale)
		} else {
			previousInstance.quantity = +previousInstance.quantity + (+quantity)
		}
		
		this._updateTotal();
	}

	Cart.prototype.addSaleRefund = function (index, sale) {
		if (this.isValidated()) {
			throw 'Cart::addSaleRefund() - Cart is already validated'
		}
		
		if (index === null || index === undefined || index < 0) {
			throw "Cart::addSaleRefund() - Malformed parameters"
		}

		if (!sale) {
			throw "Cart::addSaleRefund() - Missing parameters"
		}

		var refund = new Sale(Sale.REFUND, {
			  id            : sale.id
			, price         : sale.price
			, localPrice    : sale.localPrice
			, quantity      : sale.quantity
			, parent        : sale.key
			, deno_services : sale.deno_services
			, label         : sale.label + ' - Annulation'
		})

		this.objects.splice(index+1, 0, refund)
		this._updateTotal();
	}

	Cart.prototype.getTotalPrice = function () {
		return this.totalPrice;
	}
	
	Cart.prototype.getTotalLocalPrice = function () {
		return this.totalLocalPrice;
	}

	Cart.prototype.getContent = function () {
		return this.objects
	}
	
	Cart.prototype.updateBalance = function() {
		this.balance = +(this.recu - this.getTotalLocalPrice().toFixed(2)).toFixed(2)
	}
	
	Cart.prototype.containsUnprintedStamp = function() { 
		if (this.isEmpty()) {
			return false
		}
		
		for (var i = 0; i < this.objects.length; i++) {
			var o = this.objects[i]

		    if (o.isStamp() && o.getPrintStatus() === Sale.PRINT_STATUS_PENDING) {
		    	return true
		    }
		}

		return false;
	}

	Cart.prototype.isValidable = function () {
		return !this.isEmpty()  && this.totalPrice !== 0
	}

	Cart.prototype.isValidated = function () {
		return this.validated
	}

	var CartSingleton = {
		_instance: null,
		getInstance: function () {
			if (!this._instance) {
				this._instance = new Cart()
			}

			return this._instance
		}
	}

	return CartSingleton
}])